import { fmt } from "@/lib/api";
import { StatusBadge } from "@/components/common";
import { cn } from "@/lib/utils";

export function MilestoneSchedule({ schedule, currency }) {
  if (!schedule) return null;
  return (
    <div className="divide-y divide-slate-100" data-testid="milestone-schedule">
      <div className="px-5 py-3 text-sm text-slate-500">Template: <span className="font-medium text-slate-800">{schedule.template_name}</span> · amounts based on invoice total</div>
      {schedule.milestones.map((m, i) => (
        <div key={i} data-testid={`milestone-row-${i}`} className={cn("flex items-center gap-4 px-5 py-3", schedule.current?.index === i && "bg-[#E6F8F6]")}>
          <div className={cn("flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold", m.status === "paid" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600")}>{i + 1}</div>
          <div className="flex-1">
            <div className="text-sm font-medium text-slate-900">{m.label} <span className="text-slate-400">· {m.percent}%</span></div>
            <div className="text-xs text-slate-500">Cumulative {fmt(m.cumulative, currency)}</div>
          </div>
          <div className="text-sm tabular-nums font-medium">{fmt(m.amount, currency)}</div>
          <StatusBadge status={m.status === "due" ? "pending" : m.status === "partial" ? "part_paid" : m.status === "upcoming" ? "canceled" : "paid"} label={m.status} className="w-24 justify-center" />
        </div>
      ))}
      {schedule.current && (
        <div className="px-5 py-3 text-sm" data-testid="milestone-current-due">
          Current milestone due: <span className="font-semibold text-[#13294B]">{schedule.current.label} — {fmt(schedule.current.amount_due, currency)}</span>
        </div>
      )}
    </div>
  );
}
